import React from 'react';
import { ListItemAvatar, ListItemText, Tooltip } from '@mui/material';

import { useCurrentUser } from '@/hooks/useCurrentUser';

import {
  collapsibleItemSx,
  DropdownArrow,
  getCollapsibleButtonSx,
  StyledNavButtonOutlined
} from '../Layout/Sidebar';
import { AvatarS3PhotoKey } from '../ui/Avatar/AvatarS3PhotoKey';

import { CurrentUserPopover } from './CurrentUserPopover';

interface CurrentUserProps {
  expanded: boolean;
  handleNavigate?: VoidFunction;
}

const CurrentUser: React.FC<CurrentUserProps> = ({
  expanded,
  handleNavigate
}) => {
  const currentUser = useCurrentUser().data!;
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>();

  return (
    <>
      {/* @ts-ignore */}
      <StyledNavButtonOutlined
        {...{ ref }}
        onClick={() => setIsOpen(true)}
        sx={getCollapsibleButtonSx(expanded, 'avatar')}
      >
        <ListItemAvatar sx={collapsibleItemSx}>
          <AvatarS3PhotoKey
            s3PhotoKey={currentUser.s3_photo_key}
            sx={{
              backgroundColor: '#1DB8F2',
              width: 32,
              height: 32,
              fontSize: '14px'
            }}
          >
            {currentUser.getInitials()}
          </AvatarS3PhotoKey>
        </ListItemAvatar>
        {expanded && (
          <>
            <Tooltip title={currentUser.getFullName()}>
              <ListItemText secondary={currentUser.getPosition()}>
                {currentUser.getFullName()}
              </ListItemText>
            </Tooltip>
            <DropdownArrow isOpen={isOpen} />
          </>
        )}
      </StyledNavButtonOutlined>
      <CurrentUserPopover
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        anchorEl={ref.current!}
        handleNavigate={handleNavigate}
      />
    </>
  );
};

export default CurrentUser;
